module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-03-m-en.bab1e67393b79480652719d7c3c7753d.png";